import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios, { AxiosResponse } from "axios";

/** Normalize Odoo/list payloads into an array of records. */
export function extractContactList(payload: unknown): any[] {
  const response = payload as { data?: unknown };
  const data = response?.data ?? payload;

  if (Array.isArray(data)) return data;

  const record = (data ?? {}) as Record<string, unknown>;
  const nested = (record.result ?? record) as Record<string, unknown> | unknown[];

  if (Array.isArray(nested)) return nested;
  if (nested && typeof nested === "object") {
    const node = nested as Record<string, unknown>;
    for (const key of ["data", "countries", "cities", "tags"]) {
      if (Array.isArray(node[key])) return node[key] as any[];
    }
  }

  for (const key of ["data", "countries", "cities", "tags"]) {
    if (Array.isArray(record[key])) return record[key] as any[];
  }

  return [];
}

export const toGetContactCountries = createAsyncThunk<
  AxiosResponse<any, any>,
  string
>("contactUs/countries", async (lang) => {
  const response = await axios.get(
    `${baseUrlApi}contactus/countries?lang=${lang}`
  );
  return response;
});

export const toGetContactCities = createAsyncThunk<
  AxiosResponse<any, any>,
  { countryId: string | number; lang: string }
>("contactUs/cities", async ({ countryId, lang }) => {
  const response = await axios.get(
    `${baseUrlApi}contactus/cities?country_id=${countryId}&lang=${lang}`
  );
  return response;
});

export const toGetContactTags = createAsyncThunk<
  AxiosResponse<any, any>,
  string
>("contactUs/tags", async (lang) => {
  const response = await axios.get(`${baseUrlApi}contactus/tags?lang=${lang}`);
  return response;
});
